import {type ImagePickerAsset} from 'expo-image-picker'

export type VideoState =
  | {
      status: 'error'
      asset: ImagePickerAsset | null
      progress: number
      error: string
    }
  | {
      status: 'uploading'
      asset: ImagePickerAsset
      progress: number
      error: undefined
    }
  | {
      status: 'done'
      asset: ImagePickerAsset
      progress: number
      /** 上传后的附件绝对地址 */
      attachmentUrl: string
      error: undefined
    }

export type VideoMedia = {
  type: 'video'
  video: VideoState
}

export type VideoAction =
  | {type: 'uploading'}
  | {type: 'to_error'; error: string}
  | {type: 'to_done'; attachmentUrl: string}

export function createVideoState(asset: ImagePickerAsset): VideoState {
  return {
    status: 'uploading',
    progress: 0,
    asset: asset,
    error: undefined,
  }
}

export function videoReducer(
  state: VideoState,
  action: VideoAction,
): VideoState {
  if (action.type === 'to_error') {
    return {
      status: 'error',
      progress: 100,
      error: action.error,
      asset: state.asset ?? null,
    }
  } else if (action.type === 'uploading') {
    return {
      ...state,
      progress: 0,
    }
  } else if (action.type === 'to_done') {
    return {
      status: 'done',
      progress: 100,
      error: undefined,
      asset: state.asset!,
      attachmentUrl: action.attachmentUrl,
    }
  }
  console.error(
    'Unexpected video action (' +
      action.type +
      ') while in ' +
      state.status +
      ' state',
  )
  return state
}
